import type { RouteRecordRaw } from 'vue-router';
const routes: RouteRecordRaw[] = [
  {
    path: '/c6config',
    name: 'c6Config',
    meta: {
      layout: 'share'
    },
    children: [
      {
        path: 'calculator/:serverId',
        name: 'c6Calculator',
        component: () => import('@/views/wiki/c6config/calculator/index.vue'),
        meta: {
          title: '资源计算器'
        }
      }
    ]
  }
];

export default routes;
